import { Rutas } from '@/constants/rutas';
import { currentSeason } from '@/constants/site';
import { obtenerEquipo } from '@/data/equipos';
import { getDateYYYYMMdd } from '@/helpers/datetime-helper';
import { getMasterPhotoById } from '@/helpers/images-helper';
import { getPlayersStatus } from '@/helpers/players-helper';

export const GetJugadoresAdditionalData = (player, url, properties = []) => {
    if (!player) return null;

    const teamFound = obtenerEquipo(player?.team?.id);
    const teamSlug = teamFound ? teamFound.slug : '';
    const teamUrl = teamFound ? `${process.env.NEXT_PUBLIC_URL_FRONT}${Rutas.EQUIPO}/${teamSlug}` : '';

    return {
        '@context': 'https://schema.org',
        '@type': 'Person',
        name: player?.if?.nm ?? '',
        birthDate: player?.if?.b?.dt ? getDateYYYYMMdd(player?.if?.b?.dt) : '',
        nationality: player?.if?.nt ?? '',
        height: player?.if?.h ?? '',
        weight: player?.if?.w ?? '',
        image: getMasterPhotoById(player?.if?.id, 375),
        birthPlace: player?.if?.b
            ? {
                  name: player?.if?.b?.pl ?? '',
                  country: player?.if?.b?.c ?? '',
              }
            : null,
        url,
        memberOf: {
            '@type': 'SportsTeam',
            name: player?.team?.name ?? '',
            url: teamUrl,
        },
        team: {
            name: player?.team?.name ?? '',
            url: teamUrl,
        },
        properties: [
            {
                name: 'Estado',
                value: getPlayersStatus(player?.gs?.s, player?.gs?.sl),
            },
            ...properties,
        ],
    };
};

export const getCurrentSeason = (multiple = true) => {
    const season = parseInt(currentSeason, 10);
    if (multiple) {
        return `${season}/${season + 1}`;
    }

    return season;
};

export const getFantasyLaLigaProperties = (player) => {
    if (!player) return [];

    return [
        {
            name: 'Valor de mercado',
            value: player?.fi?.mv,
        },
        {
            name: 'Subida de mercado',
            value: player?.fi?.su,
        },
        {
            name: 'Puntuación fantasy',
            value: player?.fi?.p,
        },
        {
            name: 'Media de puntuación fantasy',
            value: player?.fi?.m?.toFixed(2),
        },
        {
            name: 'Puntos fantasy temporada anterior',
            value: player?.fi?.pls,
        },
    ];
};

export const getBiwengerProperties = (player) => {
    return [
        {
            name: 'Valor de mercado',
            value: player?.fi?.mv,
        },
        {
            name: 'Subida de mercado',
            value: player?.fi?.su,
        },
        {
            name: 'Puntuación fantasy',
            value: player?.fi?.p,
        },
        {
            name: 'Media de puntuación fantasy',
            value: player?.fi?.m?.toFixed(2),
        },
        {
            name: 'Puntos fantasy temporada anterior',
            value: player?.fi?.pls,
        },
    ];
};
